import React from 'react';

const GetInvolved = () => {
  return (
    <section id="get-involved" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-light text-center tracking-wide mb-4">GET INVOLVED WITH BOTSWALLE</h2>
        <div className="section-divider"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
          <div className="flex flex-col justify-center" data-aos="fade-right">
            <h3 className="text-xl font-light mb-6 tracking-wide">HOW CAN YOU CONTRIBUTE:</h3>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start">
                <i className="fas fa-circle text-xs mt-2 mr-3"></i>
                <span>
                  You can do so, by offering your skills, offering information and knowledge. 
                  (This helps us see how more we can grow as an organization)
                </span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-circle text-xs mt-2 mr-3"></i>
                <span>
                  You can donate your time to come serve the children. It be cooking for them, teaching etc. 
                  (we believe everyone has something to offer even if, that something is just their knowledge or skill)
                </span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-circle text-xs mt-2 mr-3"></i>
                <span>
                  You can donate to us either clothes, food parcels, toiletries and many other needed items.
                </span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-circle text-xs mt-2 mr-3"></i>
                <span>
                  You can help connect us to organizations that will be able to support and partner with us and the work we do.
                </span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-circle text-xs mt-2 mr-3"></i>
                <span>
                  You can partner with us to help build our short, medium and long term goals.
                </span>
              </li>
              <li className="flex items-start">
                <i className="fas fa-circle text-xs mt-2 mr-3"></i>
                <span>
                  <strong>MOST IMPORTANTLY:</strong> you can donate funds that can go into all the work we do monthly 
                  and yearly to help make the children's lives better.
                </span>
              </li>
            </ul>
            
            <div className="mt-12">
              <p className="text-gray-700 mb-6">
                We receive funds through Bank transfer, EFT and for international contributors PayPal and Bank transfer work.
              </p>
              
              <div className="bg-gray-50 p-6 space-y-2">
                <p className="text-gray-700"><span className="font-medium">Bank:</span> First National Bank</p>
                <p className="text-gray-700"><span className="font-medium">Account Number:</span> 63139699623</p>
                <p className="text-gray-700"><span className="font-medium">Account Holder:</span> Botswalle -the Sisterhood Youth Foundation (NPO)</p>
                <p className="text-gray-700 mt-4">
                  <span className="font-medium">PayPal:</span> 
                  <a 
                    href="https://paypal.me/botswallefoundation?country.x=ZA&locale.x=en_US" 
                    className="text-blue-600 hover:underline ml-2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    paypal.me/botswallefoundation
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div data-aos="fade-left">
            <img 
              src="/images/image00008.jpeg" 
              alt="Traditional house" 
              className="w-full object-cover h-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInvolved;